





































import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';
export default Vue.extend({
  name: 'GStoryForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    // exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    maxLength: { type: Number as PropType<number>, default: 0 },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    // rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    exclamation() {
      return [
        'Youtube URLの確認方法',
        '使用したいYouTube 動画をパソコンで開きます。',
        'ブラウザのURLをコピーして貼り付けます。',
      ];
    },
    innerRules(): any {
      // return this.rules
      return {
        required: true,
        max: 128,
        regex: /^https:\/\/www\.youtube\.com\/watch\?v=.+$/,
      };
    },
    embedUrl(): string {
      const id = this.value.replace('https://www.youtube.com/embed/', '');
      return `https://www.youtube.com/embed/${id}`;
    },
    innerValue: {
      get(): string {
        const id = this.value.replace('https://www.youtube.com/embed/', '');
        return `https://www.youtube.com/watch?v=${id}`;
      },
      set(val: string): void {
        const id = val
          .replace('https://www.youtube.com/watch?v=', '')
          .replace('https://youtu.be/', '')
          .replace('https://www.youtube.com/embed/', '');
        this.$emit('input', `https://www.youtube.com/embed/${id}`);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gTextFormProvider as any).validate();
    },
  },
});
